export default "__VITE_ASSET__e19d3bd0__"